import React, { FC, MutableRefObject } from 'react';
import { makeStyles } from 'tss-react/mui';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import IgnoredField from 'components/IgnoredField';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface IgnoreFieldProps {
  attributes: AttributesType;
  callbacks: CallbacksType;
  editable: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  showIcons: boolean;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const IgnoreField: FC<IgnoreFieldProps> = ({
  attributes,
  callbacks,
  editable,
  fieldActive,
  txn,
  showIcons,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={null}
      className={classes.iconButtonColumn}
    >
      <IgnoredField
        value={txn}
        autoFocus={fieldActive}
        inputRef={fieldActive ? (input) => { 
          focusField.current = input; // eslint-disable-line
        } : null}
        onChange={(e) => callbacks.handleMenu?.('ignored', txn, e.target.value)}
        classes={{ iconRoot: classes.iconButtonColumn }}
        show={(txn.isExcludedFromReports || txn.isExcludedFromF2S) || editable || showIcons}
      />
    </RegListItem>
  );
};

export default IgnoreField;
